module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvZWdnLXBsYWNlaG9sZGVyLmU3NWExYzQ1LnBuZyI7"